import {Modal, Button} from 'react-bootstrap'
import {IResourceCenter} from '../../../types/resourceCenter'
import {ResourceContentViewer} from './ResourceContentViewer'
import { useIntl } from 'react-intl'
import { RESOURCE_MESSAGES as R_ } from '../resourceCenterMessages'

interface ModalViewResourceProps {
  isOpen: boolean
  onClose: () => void
  resource: IResourceCenter
}

export const ModalViewResource: React.FC<ModalViewResourceProps> = ({isOpen, onClose, resource}) => {
  const intl = useIntl()
  const isUrl = !!resource.url

  return (
    <Modal show={isOpen} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <i className="bi bi-eye" />
          {resource.name}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{minHeight: 400}}>
        <ResourceContentViewer resource={resource} height={500} />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
        {intl.formatMessage(R_.close)}
        </Button>
        {isUrl && (
          <Button
            variant="primary"
            onClick={() => window.open(resource.url!, '_blank', 'noopener,noreferrer')}
          >
            <i className="bi bi-box-arrow-up-right me-2" />
            {intl.formatMessage(R_.openNewTab)}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
